<table role="presentation" style="width: 100%; text-align: center; border-spacing: 0; border-collapse: collapse;"  contenteditable="false">
    <tr>
      <td style="padding: 10px;">
        <!-- Banner Upload -->
        <label for="bannerUpload" 
          *ngIf="!bannerPreview" 
          style="cursor: pointer; padding: 10px 16px; border-radius: 4px; background-color: #6c757d; color: white; border: none;">
          Upload Banner
        </label>
      </td>
    </tr>
    <tr>
      <td style="padding: 10px;">
        <input id="bannerUpload" 
          type="file" 
          (change)="onBannerUpload($event)" 
          accept="image/*" 
          style="display: none;">
      </td>
    </tr>
    <tr>
      <td style="padding: 10px;">
        <img [src]="imgUrl + bannerPreview" 
          alt="Company Banner" 
          *ngIf="bannerPreview" 
          style="max-width: 100%; height: auto; margin-top: 10px; margin-bottom: 10px; border-radius: 4px; box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);">
      </td>
    </tr>
  </table>
  